<template>
    <div class="user-section" :class="{ 'is-expanded': expanded }">
        <!-- Menú inline ANTES del trigger en el DOM: vivimos al bottom del
             sidebar (flex column), así al aparecer el menú el contenedor
             crece hacia arriba sin mover el trigger. -->
        <div
            v-if="showInlineMenu"
            id="sidebar-user-menu"
            class="user-menu-inline"
        >
            <UserMenu :user="user" />
        </div>
        <button
            ref="trigger"
            type="button"
            class="user-trigger"
            v-tooltip="!expanded ? { content: user.first_name || 'Menú de usuario', theme: 'sidebar-tooltip' } : ''"
            :aria-expanded="String(menuOpen)"
            aria-controls="sidebar-user-menu"
            aria-label="Menú de usuario"
            @click="onClick"
        >
            <span class="avatar-circle">
                <Avatar class="avatar-icon" />
            </span>
            <span v-if="user.first_name" class="user-name">
                {{ user.first_name }}
            </span>
            <ArrowDown
                class="user-chevron"
                :class="{ 'is-rotated': menuOpen }"
            />
        </button>
    </div>
</template>

<script>
import ArrowDown from "@/components/svg/ArrowDown.vue";
import Avatar from "@/components/svg/Avatar.vue";
import UserMenu from "@/components/dashboard/UserMenu";

export default {
    name: "SidebarUserSection",
    components: { ArrowDown, Avatar, UserMenu },
    props: {
        user: { type: Object, required: true },
        expanded: { type: Boolean, default: false },
        menuOpen: { type: Boolean, default: false },
    },
    computed: {
        showInlineMenu() {
            // Solo aplica en modo expanded — collapsed usa flyout (manejado
            // por el padre via SidebarFlyout).
            return this.menuOpen && this.expanded;
        },
    },
    methods: {
        onClick() {
            // Emitimos el button DOM element directo (no el event) porque
            // event.currentTarget queda null al re-emitirse via $emit chain
            // de Vue — el ref interno siempre es el elemento real.
            this.$emit("toggle", this.$refs.trigger);
        },
    },
};
</script>

<style lang="scss" scoped>
.user-section {
    border-top: 1px solid var(--sidebar-rule, rgba(16, 24, 40, 0.08));
    padding: 8px;
}

.user-trigger {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 6px 8px;
    background-color: transparent;
    border: none;
    border-radius: var(--sidebar-radius, 6px);
    cursor: pointer;
    transition: background-color var(--app-transition-fast);

    &:hover {
        background-color: var(--sidebar-hover, rgba(16, 24, 40, 0.03));
    }

    &:focus-visible {
        outline: 2px solid var(--sidebar-accent, #0d5154);
        outline-offset: -2px;
    }
}

.avatar-circle {
    flex-shrink: 0;
    width: 32px;
    height: 32px;
    background-color: var(--sidebar-hover, rgba(16, 24, 40, 0.03));
    border: 1px solid var(--sidebar-rule, rgba(16, 24, 40, 0.08));
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
}

.avatar-icon {
    width: 20px;
    height: 20px;
}

.user-name {
    flex: 1;
    text-align: left;
    font-size: 14px;
    font-weight: 600;
    color: var(--sidebar-ink, #1d2939);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    opacity: 0;
    max-width: 0;
    transition: opacity var(--app-transition-fast) 0.05s,
        max-width var(--app-transition-base);
}

.user-section.is-expanded .user-name {
    opacity: 1;
    max-width: 180px;
}

.user-chevron {
    width: 14px;
    height: 14px;
    flex-shrink: 0;
    color: var(--sidebar-ink-faint, #98a2b3);
    opacity: 0;
    transition: opacity var(--app-transition-fast),
        transform var(--app-transition-base);

    &.is-rotated {
        transform: rotate(180deg);
    }
}

.user-section.is-expanded .user-chevron {
    opacity: 1;
}

.user-menu-inline {
    margin-bottom: 8px;
}
</style>
